import styled from 'styled-components';
import tw, { css } from 'twin.macro';

export const StyledWhatsappIcon = styled.img``;
